module.exports = __webpack_public_path__ + "static/media/kgw8-logo.13bbdfa7.svg";